export default __webpack_public_path__ + "fonts/inter-latin-900-normal.273eaefea8d63aef8018.woff2";